import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentService } from '../../../../../../services/document/document.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-last-price-product',
  templateUrl: './last-price-product.component.html',
  styleUrls: ['./last-price-product.component.scss']
})
export class LastPriceProductComponent implements OnInit {
  productId!: number;
  lastPrixHt: number = 0;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
    this.loadLastPrixHt();
  }

  loadLastPrixHt(): void {
    this.documentService.getLastPrixHt(this.productId).subscribe({
      next: (response: any) => {
        if (response?.success === true && response?.data) {
          this.lastPrixHt = parseFloat(String(response.data.prix_achat || 0)) || 0;
        } else {
          this.lastPrixHt = 0;
        }
      },
      error: (err) => {
        console.error('Erreur lors de la récupération du dernier prix HT:', err);
        this.lastPrixHt = 0;
      }
    });
  }

  formatPrice(price: number | string | null | undefined): string {
    const numPrice = typeof price === 'number' ? price : parseFloat(String(price || 0));
    if (isNaN(numPrice)) {
      return '0,000';
    }
    return numPrice.toFixed(3).replace('.', ',');
  }

}
